import { render, staticRenderFns } from "./Page6.vue?vue&type=template&id=5a9681ae&scoped=true&"
import script from "./Page6.vue?vue&type=script&lang=js&"
export * from "./Page6.vue?vue&type=script&lang=js&"
import style0 from "./Page6.vue?vue&type=style&index=0&id=5a9681ae&prod&lang=css&"
import style1 from "./Page6.vue?vue&type=style&index=1&id=5a9681ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9681ae",
  null
  
)

export default component.exports